const TOKEN = 'token';

const BASE_URL = window.location.origin;

const LOGOUT_URL = process.env.VUE_APP_LOGOUT_URL
  ? process.env.VUE_APP_LOGOUT_URL
  : 'https://www.wheezo.com';

export { TOKEN, BASE_URL, LOGOUT_URL };
